<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報 - パスワード編集</h3>
      </div>
      <div class="page-block__inner">
        <div class="profile-info">
          <form :class="{ 'form--error': errors }">
            <div class="form-wrap form-wrap--profile u-no-margin-top">
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="password_current">現在のパスワード</label>
                </div>
                <div class="form-item">
                  <input
                    id="password_current"
                    v-model="password_current"
                    class="form-control"
                    type="password">
                  <p
                    v-if="errors['password_current']"
                    class="error-text">
                    {{ errors['password_current'][0] }}
                  </p>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="password">新しいパスワード</label>
                </div>
                <div class="form-item">
                  <input
                    id="password"
                    v-model="password"
                    class="form-control"
                    type="password">
                  <p
                    v-if="errors['password']"
                    class="error-text">
                    {{ errors['password'][0] }}
                  </p>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="password_confirmation">新しいパスワード（再入力）</label>
                </div>
                <div class="form-item">
                  <input
                    id="password_confirmation"
                    v-model="password_confirmation"
                    class="form-control"
                    type="password">
                </div>
              </div>
            </div>
            <div class="c-btn-wrap">
              <a
                class="c-btn"
                @click.prevent="onSaveClicked">
                内容を保存
                <span class="c-btn__icon-arrow"></span>
              </a>
              <router-link
                :to="{ name: 'profile' }"
                class="c-btn c-btn--back c-btn--back-left">
                戻る
                <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  /* eslint camelcase: ["error", {allow: ["password_confirmation", "password_current"]}] */
  name: 'ProfileEditPassword',
  components: { HeaderBar },
  data() {
    return {
      password_current: '',
      password: '',
      password_confirmation: '',
      errors: {},
    }
  },
  methods: {
    async onSaveClicked() {
      window.scrollTo(0, 0)
      const { password, password_confirmation, password_current } = this.$data
      try {
        await window.axios.put('/api/client/user/change-password', {
          password_current,
          password,
          password_confirmation,
        })
        await this.$router.push({ name: 'profile' })
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
      }
    },
  },
}
</script>

<style scoped>

</style>
